import React, { useEffect, useState } from "react";
import useHttpHook from "../../Hooks/HttpHook";
import { MarkNotificationAsRead } from "../../utils/ApiConstant";
import { timeSince } from "../../utils/Helper";
import MainComponentWrapper from "../Common/MainComponentWrapper";
import MainPagination from "../Common/MainPagination";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { showErrorToast } from "../../utils/notify";

const Notification = ({
  notificationList,
  isLoading,
  isError,
  getNotifications,
}) => {
  const [loading, sendRequest, error] = useHttpHook();
  const [openMenuId, setOpenMenuId] = useState(null);

  const items = notificationList?.data?.itemsList || [];

  const getNotificationLink = (item) => {
    if (item?.orderId) return `/myOrder/${item.orderId}`;
    if (item?.eventId) return `/organizer/myEarning/${item.eventId}`;
    return null;
  };

  const handleMarkNotificationRead = async (id) => {
    try {
      const res = await sendRequest(`${MarkNotificationAsRead}/${id}`, {
        method: "put",
      });
      if (res.status === 1) {
        getNotifications(notificationList?.data?.paginator?.currentPage || 1);
        setOpenMenuId(null);
      }
    } catch (err) {
      console.log({ error: err });
    }
  };

  useEffect(() => {
    if (error) {
      if (toast.isActive(error) === false) {
        showErrorToast(error);
        if (error === "You are unAuthrised") {
          window.location.href = `${process.env.REACT_APP_MERCH_URL}/login`;
        }
      }
    }
  }, [error]);

  return (
    <MainComponentWrapper
      errorInfo={isError || error}
      Loading={isLoading || loading}
    >
      {notificationList !== null ? (
        items.length > 0 ? (
          <MainPagination
            getEventsMethod={getNotifications}
            MainData={notificationList}
            PaginationType="paginate"
          >
            <div className="event-notifications-list" role="list">
              {items.map((item) => {
                const link = getNotificationLink(item);
                const isUnread = item.isRead === false;
                const MessageTag = link ? Link : "div";
                const messageProps = link
                  ? { to: link, className: "event-notification-message-link" }
                  : { className: "event-notification-message-link is-static" };

                return (
                  <article
                    key={item._id}
                    role="listitem"
                    className={`event-notification-card${
                      isUnread ? " is-unread" : ""
                    }`}
                  >
                    <div className="event-notification-avatar" aria-hidden="true">
                      <img
                        src="https://dev.danzflo.com/assets/img/logo.png"
                        alt=""
                      />
                    </div>

                    <div className="event-notification-body">
                      <MessageTag {...messageProps}>
                        <p className="event-notification-text">{item.message}</p>
                        <span className="event-notification-time">
                          {timeSince(item.createdAt)}
                        </span>
                      </MessageTag>
                    </div>

                    {isUnread && (
                      <div className="event-notification-menu">
                        <button
                          type="button"
                          className="event-notification-menu-btn"
                          aria-label="Notification actions"
                          aria-expanded={openMenuId === item._id}
                          disabled={loading}
                          onClick={() =>
                            setOpenMenuId(
                              openMenuId === item._id ? null : item._id
                            )
                          }
                        >
                          <i className="bi bi-three-dots-vertical" aria-hidden="true" />
                        </button>
                        {openMenuId === item._id && (
                          <div className="event-notification-dropdown">
                            <button
                              type="button"
                              className="event-notification-dropdown-item"
                              onClick={() => handleMarkNotificationRead(item._id)}
                            >
                              Mark as Read
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </article>
                );
              })}
            </div>
          </MainPagination>
        ) : (
          <div className="event-notifications-empty">
            <i className="bi bi-bell" aria-hidden="true" />
            <p>No notifications yet</p>
          </div>
        )
      ) : null}
    </MainComponentWrapper>
  );
};

export default Notification;
